module.exports = __webpack_public_path__ + "img/type--2-spans--multiple-lang--pt.6081b2e8.jpg";